<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title>Daily Light: Morning &amp; Evening</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="txc32" id="p0001-01-0d"><i>To:</i></p>
<p class="line1"></p>
<p class="txc2" id="p0001-01-0"><i>From:</i></p>
<p class="line1"></p>
<p class="txc2" id="p0001-04-2"><i>Date:</i></p>
<p class="line1"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?43438888